<template v-if="groups">
  <div class="drag-container" v-drag-and-drop:options="options">
    <div class="drag-list">
      <div class="drag-column" v-for="group in groups" :key="group.id">
        <vue-draggable-group
          v-model="group.items"
          :groups="groups"
          :data-id="group.id"
          @change="onGroupsChange"
        >
          <ul class="list-group drag-inner-list" :data-id="group.id">
            <li
              class="drag-item list-group-item list-group-item-action"
              v-for="item in group.items"
              :key="item.id"
              :data-id="item.id"
            >
              <span
                class="badge rounded-pill bg-secondary-subtle text-secondary"
                style="margin-right:20px"
              >{{item.order}}</span>
              {{ item.name }}
              <app-button-delete-confirm class="float-end" @handle="onRemoveItem(item.id)" />
            </li>
          </ul>
        </vue-draggable-group>
      </div>
    </div>
  </div>
</template>

<script>
import AppButtonDeleteConfirm from "@/components/AppButtonDeleteConfirm/AppButtonDeleteConfirm.vue";
export default {
  props: {
    groups: {
      type: Array,
      default: () => []
    }
  },
  components: {
    AppButtonDeleteConfirm
  },
  data() {
    return {
      options: {
        dropzoneSelector: ".drag-inner-list",
        draggableSelector: ".drag-item"
      }
    };
  },
  methods: {
    onGroupsChange(e) {
      this.ordered();
      console.log({ e });
    },
    onRemoveItem(id) {
      let temp = this.groups[0].items.filter(el => el.id != id);
      this.groups[0].items = temp;
      this.ordered();
    },
    ordered() {
      this.groups[0].items.forEach((item, index) => {
        item.order = index + 1; // Atualizar ordem dos itens
      });
    }
  }
};
</script>

